export enum AccessRightFlags {
  Unauthorized = "Unauthorized",
  Authorized = "Authorized",
  IsMasterAccountHolder = "IsMasterAccountHolder",
  IsFullAdmin = "IsFullAdmin",
}
